module.exports = __webpack_public_path__ + "static/media/regal-rush-vertical-transparent-bg-dark-gold-250x250.855f7e37.png";